import { render } from "./EditImpiantiPage.vue?vue&type=template&id=ce74e2ba"
import script from "./EditImpiantiPage.vue?vue&type=script&lang=js"
export * from "./EditImpiantiPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__